import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const PageTitle = ({ as: Component, className, children }) => (
  <Component
    className={cx(
      'font-display leading-tight uppercase text-4xl font-bold text-white mb-8',
      className
    )}
  >
    {children}
  </Component>
);

PageTitle.propTypes = {
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

PageTitle.defaultProps = {
  as: 'h1',
  className: '',
};

export default PageTitle;
